exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".label{\n    font-weight: bold;\n    margin-right: 15px;\n}\n\n.ProductLable{\n    padding: 0px 5px 0px 0px;\n}", "", {"version":3,"sources":["/home/dev/bitool-new/client/app/main/reports/Invoicereturn-vs-po/Invoicereturn_vs_po.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;CACtB;;AAED;IACI,yBAAyB;CAC5B","file":"Invoicereturn_vs_po.css","sourcesContent":[".label{\n    font-weight: bold;\n    margin-right: 15px;\n}\n\n.ProductLable{\n    padding: 0px 5px 0px 0px;\n}"],"sourceRoot":""}]);

// exports
